import { render } from "./AgregarObservacionesStepper.vue?vue&type=template&id=7648d23e"
import script from "./AgregarObservacionesStepper.vue?vue&type=script&lang=js"
export * from "./AgregarObservacionesStepper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__